import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

export function ExportsApi() {
    return createActions({
        Export: {
            method: 'GET',
            url: `${BASE_PATH_API}/exports/:type`,
            responseType: 'blob',
            transformResponse: function transformResponse(response, headers) {
                const contentDisposition = headers.get('content-disposition')
                    ? headers.get('content-disposition').split('filename=')
                    : [];

                return {
                    data: response,
                    filename: contentDisposition && contentDisposition.length > 1
                        ? contentDisposition[contentDisposition.length - 1]
                        : null
                };
            }
        },
        getPopulateAFTFile: {
            method: 'GET',
            url: `${BASE_PATH_API}/exports/populateAFTFile/:bankGlAccountId`
        },
        downloadAFTExportFile: {
            method: 'GET',
            url: `${BASE_PATH_API}/exports/downloadAFTFile`
        }
    });
}

ExportsApi.$inject = [];
